import {
  DefinitionActionKindEnum,
  DefinitionActionSubKindEnum,
  type ActionResponse,
} from '@acme/api';

export function findAction(
  actions: ActionResponse[] | null | undefined,
  kind: DefinitionActionKindEnum,
  subKind?: DefinitionActionSubKindEnum
): ActionResponse | null {
  if (!actions?.length) return null;

  if (subKind == null) {
    return actions.find((a) => a.kind === kind) ?? null;
  }

  return actions.find((a) => a.kind === kind && a.subKind === subKind) ?? null;
}
